import {Fetch} from "./Fetch";

export class LookupsAPI {

    static async getIndustries(){
        let data = await Fetch('GET', 'api/lookups/industries');
        return data;
    }

    static async getCountries(){
        let data = await Fetch('GET', 'api/lookups/countries/');
        return data;
    }

    static async getCities(countryId){
        let data = await Fetch('GET', `api/lookups/cities/${countryId}`);
        return data;
    }

    static async getStates(countryId){
        let data = await Fetch('GET', `api/lookups/states/${countryId}`);
        return data;
    }

    static async getLookups(group){
        let data = await Fetch('GET', `api/lookups/list/${group}`);
        return data;
    }

    static async uploadImage(file){
        let fd = new FormData()
        fd.append('file', file)
        let data = await Fetch('POST', `api/lookups/upload_image/test`, fd);
        return data;
    }
}
